import type { Component } from "solid-js";
import { twMerge } from "tailwind-merge";

type ProcessingSpinnerProps = {
  class?: string;
};

/**
 * A simple processing spinner component. Best to provide a w/h class to
 * control size. Defaults to w-3 h-3 if no class is provided.
 *
 * @param props
 * @constructor
 */
export const ProcessingSpinner: Component<ProcessingSpinnerProps> = (props) => {
  return (
    <div
      class={twMerge(
        "animate-spin border border-blue-500 rounded-full flex-shrink-0 h-3 w-3",
        props.class,
        "border-t-transparent",
      )}
    />
  );
};
